/* eslint-disable */
export default {
  monday: 'L',
  tuesday: 'T',
  wednesday: 'Mi',
  thursday: 'J',
  friday: 'V',
  saturday: 'D',
  sunday: 'D',
} as const;

// @key: @#@"monday"@#@ @source: @#@"M"@#@
// @key: @#@"tuesday"@#@ @source: @#@"T"@#@
// @key: @#@"wednesday"@#@ @source: @#@"W"@#@
// @key: @#@"thursday"@#@ @source: @#@"T"@#@
// @key: @#@"friday"@#@ @source: @#@"F"@#@
// @key: @#@"saturday"@#@ @source: @#@"S"@#@
// @key: @#@"sunday"@#@ @source: @#@"S"@#@
